export { default as PhoneIcon } from './PhoneIcon';
